const bog = require('bog');
const ip = require('ip');

/* TODO: We have the same functions in utils/number.js, but they use ES6. */
const pad = n => n < 10 ? `0${n}` : n;
const dateFormatter = (date) => {
  const Y = date.getFullYear();
  const M = pad(date.getMonth() + 1);
  const D = pad(date.getDate());
  const h = pad(date.getHours());
  const m = pad(date.getMinutes());
  const s = pad(date.getSeconds());
  const ms = pad(date.getMilliseconds());
  return `${Y}.${M}.${D} ${h}:${m}:${s}.${ms}`;
};

bog.config().format = (level, args) => {
  const date = new Date();
  // TODO: replace the placeholder when needed
  const styledArgs = [
    `[${level.toUpperCase()}]`,
    `[${dateFormatter(date)}]`,
    `[${ip.address()}]`,
    '[uuid]',
    '[thread]',
    '[class]',
    '-',
  ];
  if (args && args.length > 0) styledArgs.push(`${args.join(' ')}`);
  return styledArgs;
};

const bogWarn = bog.warn;

// disable warning on client side
bog.warn = (...args) => {
  if (typeof (window) === 'undefined') {
    bogWarn(...args);
  }
};

const morebog = bog;

module.exports = morebog;
